// --------------------------------------------------------------------------
// MODULE #? – Activity Detail Print
// --------------------------------------------------------------------------
// Author:      Richard Bultitude
// Email:       frontend@thisiszone.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {
  var context = options.context;

  function init() {
    context[0].addEventListener('click', function (e) {
      e.preventDefault();
      window.print();
    });
  }

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/activities/activity-detail-print.js
// module id = 207
// module chunks = 0